export default __webpack_public_path__ + "static/media/child_avatar.55ab03b0.png";